<div class="trucker-enrollment bg-aircontainer">
    <div class="container h-100 scroll-y">
        <div class="trucker-enrollment__container row justify-content-center align-items-center py-3">
            <div class="col-12 col-lg-9">
                <div class="trucker-enrollment__content d-flex flex-column flex-md-row">
                    <div
                        class="trucker-enrollment__brand d-flex flex-row flex-md-column justify-content-between flex-wrap p-3">
                        <div class="login__brand__title text-center mt-md-3">
                            <app-auth-logo></app-auth-logo>
                        </div>
                    </div>
                    <form class="trucker-enrollment__form p-3 flex-grow-1 bg-white" [formGroup]="truckerEnrollmentForm"
                        (submit)="registerContact($event,truckerEnrollmentForm)" novalidate>
                        <h2 class="mb-4">Almost done!<br>
                            <small>Create your password to continue</small>
                        </h2>
                        <div class="form-group">
                            <label>Password</label>
                            <input type="password" class="form-control" placeholder="Enter your password"
                                formControlName="usr_password" id='usr_password'>
                            <app-invalid-field fieldName="usr_password"
                                [messageList]="formErrors.usr_password"></app-invalid-field>
                        </div>

                        <div class="form-group">
                            <label>Confirm password</label>
                            <input type="password" class="form-control" placeholder="Confirm password"
                                formControlName="usr_password_confirm">
                            <app-invalid-field fieldName="usr_password_confirm"
                                [messageList]="formErrors.usr_password_confirm"></app-invalid-field>
                            <app-invalid-field fieldName="usr_password_confirm"
                                [messageList]="formErrors.usr_password_confirm" [mismatch]="true"></app-invalid-field>
                        </div>

                        <div class="alert-login danger" [class.invisible]="!alertMessage">
                            <span>{{alertMessage}}</span>
                        </div>
                        <app-password-validation-issues [passwordValidationResponse]="passwordValidationResponse">
                        </app-password-validation-issues>
                        <div class="form-group">
                            <button type="submit" class="btn btn-primary mt-3 mb-0" [disabled]="sending"
                                [class.loading]="sending">
                                Continue
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>